"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardBody = exports.StyledCardHeader = exports.StyledCard = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _card = require("../../../../styles/2_commonComponentStyles/card");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Yes, this may be excessively broken apart...
//
// The intent is that if we end up reusing card-like styling for anything that doesnt need all of the card-like styles,
//    then the card-specific stuff can be moved here, shared stuff can be kept in the 2_commonComponentStyles file,
//    and then that file can be renamed to match its new use.
// External
var StyledCard = _styledComponents.default.div.withConfig({
  displayName: "Cardstyles__StyledCard",
  componentId: "c377m2-0"
})(["", ";", ";"], _card.baseCard, _card.cardThemes);

exports.StyledCard = StyledCard;

var StyledCardHeader = _styledComponents.default.div.withConfig({
  displayName: "Cardstyles__StyledCardHeader",
  componentId: "c377m2-1"
})(["", ";", ";"], _card.baseCardHeader, _card.cardHeaderThemes);

exports.StyledCardHeader = StyledCardHeader;

var StyledCardBody = _styledComponents.default.div.withConfig({
  displayName: "Cardstyles__StyledCardBody",
  componentId: "c377m2-2"
})(["", ";", ";"], _card.baseCardBody, _card.cardBodyThemes);

exports.StyledCardBody = StyledCardBody;